import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const usedCookingOilSoftRule = {
    id: StowageRuleId.UsedCookingOilSoftRule,
    name: 'A cargo with product name "Used cooking oil (m)" or "Used cooking oil (Triglycerides, C16-C18 and C18 unsaturated) (m) (n)" is stowed in any tank',
    lastUpdatedUtc: '2014-05-15T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                operator: BooleanOperator.OR,
                children: [
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category name',
                                    fieldPath: 'cargo.product.category.name',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'string',
                                    referenceValue: 'Used cooking oil (m)',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                    {
                        leaf: {
                            properties: [
                                {
                                    name: 'Product category name',
                                    fieldPath: 'cargo.product.category.name',
                                    type: 'array',
                                    location: StowageRulePropertyLocation.Tank,
                                },
                                {
                                    name: 'Reference value',
                                    type: 'string',
                                    referenceValue: 'Used cooking oil (Triglycerides, C16-C18 and C18 unsaturated) (m) (n)',
                                    location: StowageRulePropertyLocation.NA,
                                },
                            ],
                            scope: StowageRuleTestScope.Tank,
                            operator: StowageRulePropertyOperator.Equals,
                        },
                    },
                ],
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Tank content weight',
                            fieldPath: 'getStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter:
            'Several shipping names could be applicable for UCO pending composition. Make sure correct shipping name and MARPOL category is applied for this shipment.',
    },
} as StowageRuleBM;
